import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Uc2Assignee } from '#models';

/**
 * Directory lookup for people who can be assigned work.
 *
 * Fixture-backed for now. Searching the directory needs the delegated Graph
 * scope User.ReadBasic.All, which is not on the app registration and needs
 * tenant admin consent. Once granted, replace the fixture with
 * GET https://graph.microsoft.com/v1.0/users?$search="displayName:{term}"
 * and add that URL to the MSAL protectedResourceMap. The shape below already
 * matches the Graph user resource so callers will not change.
 */
const DIRECTORY: Uc2Assignee[] = [
  { id: 'b1f0-okan-01', displayName: 'Adebayo Bello', mail: 'abello@chevron.com', jobTitle: 'Offshore Operations Technician' },
  { id: 'b1f0-okan-02', displayName: 'Kwame Mensah', mail: 'kmensah@chevron.com', jobTitle: 'Production Operator' },
  { id: 'b1f0-okan-03', displayName: 'Tochi Okafor', mail: 'tokafor@chevron.com', jobTitle: 'Offshore Operations Supervisor' },
  { id: 'b1f0-ioc-01', displayName: 'Dami Achebe', mail: 'dachebe@chevron.com', jobTitle: 'Production Analyst' },
  { id: 'b1f0-ioc-02', displayName: 'Rafael Torres', mail: 'rtorres@chevron.com', jobTitle: 'Production Engineer' },
  { id: 'b1f0-ioc-03', displayName: 'Sara Ibrahim', mail: 'sibrahim@chevron.com', jobTitle: 'Facilities Engineer' },
  { id: 'b1f0-ioc-04', displayName: 'Ngozi Eze', mail: 'neze@chevron.com', jobTitle: 'Lift Gas Specialist' },
];

@Injectable({ providedIn: 'root' })
export class DirectoryService {
  searchPeople(term: string): Observable<Uc2Assignee[]> {
    const query = term.trim().toLowerCase();
    if (!query) {
      return of([]);
    }

    return of(
      DIRECTORY.filter(person =>
        `${person.displayName} ${person.mail} ${person.jobTitle}`.toLowerCase().includes(query),
      ).slice(0, 6),
    );
  }
}
